import { ReactNode, useEffect } from "react";
import { useIntercom } from "react-use-intercom";
import { useSession } from "next-auth/react";

const WithIntercom = ({ children }: { children: ReactNode }) => {
    const session = useSession();
    const { boot } = useIntercom();

    useEffect(() => {
        if (
            session.data?.user.email &&
            session.data.user.name &&
            session.data.intercomJwt
        ) {
            boot({
                email: session.data.user.email,
                name: session.data.user.name,
                intercomUserJwt: session.data.intercomJwt,
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        session.data?.user.email,
        session.data?.user.name,
        session.data?.intercomJwt,
    ]);

    return children;
};

export default WithIntercom;
